import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i1898575559__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Hygiene", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i1898575559__cls-1{fill:none}.i1898575559__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M109.86 99.54H82.13c-1.62 0-2.93 1.3-2.93 2.91v34.54c0 1.6 1.32 2.91 2.93 2.91h27.73c1.62 0 2.93-1.3 2.93-2.91v-34.54c0-1.6-1.32-2.91-2.93-2.91",
      class: "i1898575559__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M111.8 25.83c-3.29-5.85-9.19-9.34-15.8-9.34s-12.51 3.49-15.8 9.34L18.45 135.67c-3.32 5.9-3.26 12.92.16 18.77 3.32 5.67 9.16 9.06 15.64 9.06h123.5c6.48 0 12.32-3.38 15.64-9.06 3.42-5.85 3.48-12.86.16-18.77zM79.62 56.34c.75-.75 1.77-1.17 2.82-1.17h24.21v8h-6.66V77h10.97v8H81.02v-8h10.97V63.17h-7.9l-7.16 7.14-5.65-5.67 8.33-8.3Zm41.17 80.65c0 6.02-4.9 10.91-10.93 10.91H82.13c-6.03 0-10.93-4.89-10.93-10.91v-34.54c0-6.02 4.9-10.91 10.93-10.91h27.73c6.03 0 10.93 4.89 10.93 10.91z",
      class: "i1898575559__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M118.77 21.91C114.05 13.51 105.53 8.49 96 8.49s-18.05 5.02-22.77 13.42L11.47 131.75c-4.73 8.41-4.64 18.4.23 26.73 4.77 8.15 13.2 13.02 22.54 13.02h123.5c9.35 0 17.78-4.87 22.54-13.02 4.87-8.33 4.96-18.32.23-26.73zm54.62 132.53c-3.32 5.67-9.16 9.06-15.64 9.06H34.25c-6.48 0-12.32-3.38-15.64-9.06-3.42-5.85-3.48-12.86-.16-18.77L80.2 25.83c3.29-5.85 9.19-9.34 15.8-9.34s12.51 3.49 15.8 9.34l61.75 109.84c3.32 5.9 3.26 12.92-.16 18.77",
      class: "i1898575559__cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M109.86 91.54H82.13c-6.03 0-10.93 4.89-10.93 10.91v34.54c0 6.02 4.9 10.91 10.93 10.91h27.73c6.03 0 10.93-4.89 10.93-10.91v-34.54c0-6.02-4.9-10.91-10.93-10.91m2.93 45.45c0 1.6-1.32 2.91-2.93 2.91H82.13c-1.62 0-2.93-1.3-2.93-2.91v-34.54c0-1.6 1.32-2.91 2.93-2.91h27.73c1.62 0 2.93 1.3 2.93 2.91zM84.1 63.17H92V77H81.03v8h29.94v-8H100V63.17h6.66v-8H82.45c-1.06 0-2.07.42-2.82 1.17l-8.33 8.3 5.65 5.67 7.16-7.14Z",
      class: "i1898575559__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "hygine"}) } }